<template>
    <div class="backoffice-home">
        <v-row>
            <v-col cols="12" md="6">
                <v-card @click="openKioskMode()" :title="$page.props.lang.start_kiosk || 'Start Quick appointment mode'">
                    <v-card-title class="font-weight-regular">{{ $page.props.lang.kiosk_classes || "Switch to Quick appointment mode" }}
                        <v-spacer></v-spacer>
                         <v-btn icon>
                            <v-icon>mdi-export</v-icon>
                        </v-btn>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="$page.props.p['reports']">
            <v-col cols="12" sm="6" md="3">
                <v-card elevation="1">
                    <v-card-title>{{ $page.props.lang.active_members || "Active members" }}</v-card-title>
                    <v-card-subtitle>{{ $page.props.lang.total_active_members || "Total active members" }}</v-card-subtitle>
                    <v-row>
                        <v-col cols="4">
                            <v-avatar size="50" tile>
                                <v-icon>mdi-account-multiple-check-outline</v-icon>
                            </v-avatar>
                        </v-col>
                        <v-col cols="8">
                            <h2 class="value">{{ active_members }}</h2>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-card elevation="1">
                    <v-card-title>{{ $page.props.lang.latest_members || "Latest members" }}</v-card-title>
                    <v-card-subtitle>{{ $page.props.lang.last30 || "Last 30 days" }}</v-card-subtitle>
                    <v-row>
                        <v-col cols="4">
                            <v-avatar size="50" tile>
                                <v-icon>mdi-account-arrow-right-outline</v-icon>
                            </v-avatar>
                        </v-col>
                        <v-col cols="8">
                            <h2 class="value">{{ latest_members }}</h2>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-card elevation="1">
                    <v-card-title>{{ $page.props.lang.earnings || "Earnings" }}</v-card-title>
                    <v-card-subtitle>{{ $page.props.lang.this_month || "This month" }}</v-card-subtitle>
                    <v-row>
                        <v-col cols="4">
                            <p class="mb-2">{{$page.props.organization.settings.currency}}</p>
                        </v-col>
                        <v-col cols="8">
                            <h2 class="value">{{ earnings }}</h2>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-card elevation="1">
                    <v-card-title>{{ $page.props.lang.debts || "Debts" }}</v-card-title>
                    <v-card-subtitle>{{ $page.props.lang.total_debts || "Total debts" }}</v-card-subtitle>
                    <v-row>
                        <v-col cols="4">
                            <p class="mb-2">{{$page.props.organization.settings.currency}}</p>
                        </v-col>
                        <v-col cols="8">
                            <h2 class="value">{{ debts }}</h2>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-card elevation="1" v-if="$page.props.p['members.manage']">
                    <v-overlay :value="loadingUnpaidMemberships" :absolute="true" :light="true">
                            <v-progress-circular
                                color="#8b1f62"
                                indeterminate
                                size="64"
                            ></v-progress-circular>
                        </v-overlay>
                    <v-card-title>{{ $page.props.lang.unpaid_memberships || "Unpaid memberships"}}</v-card-title>
                    <v-card-text>
                        <v-data-table
                        v-if="unpaidMemberships.total != 0"
                        :headers="unpaidMembershipsHeaders"
                        :items="unpaidMemberships.data"
                        :server-items-length="unpaidMemberships.total"
                        item-key="item.id"
                        :items-per-page="unpaidMemberships.per_page"
                        mobile-breakpoint="0"
                        hide-default-footer>
                            <template v-slot:item.full_name="{ item }">
                                <inertia-link :href="'/backoffice/members/details/'+item.member_id +'/overview'" class="name">
                                    {{ item.full_name }}
                                </inertia-link>
                            </template>
                            <template v-slot:item.name="{ item }">
                                <inertia-link :href="'/backoffice/members/details/'+item.member_id +'/subscription/'+item.membership_id" class="membership_name">
                                    {{ item.name}}
                                </inertia-link>
                            </template>
                            <template v-slot:item.current_period="{ item }">
                                    {{item.start_date | formatDate}} - {{ item.end_date | formatDate}}
                            </template>
                            <template v-slot:item.price="{ item }">
                                    {{ item.price }}
                            </template>
                            <template v-slot:item.action="{ item }">
                                 <v-btn @click="showPaymentModal(item.id, item.member_id)" :id="'payment' + item.id" v-show="$page.props.p['members.manage']" icon style="background:#eeeeee">
                                    <v-icon>mdi-cash-multiple</v-icon>
                                    <v-tooltip :activator="'#payment'+ item.id" bottom open-delay="500">
                                        <span>{{$page.props.lang.addPayment || "Add Payment"}}</span>
                                    </v-tooltip>
                                </v-btn>
                            </template>
                        </v-data-table>
                    <v-card-text v-else class="text-center font-weight-light text--disabled">{{ $page.props.lang.no_memberships_unpaid || "All memberships are paid..."}}</v-card-text>
                    <v-pagination v-model="unpaidMemberships.current_page"
                                :length="unpaidMemberships.last_page"
                                @input="currentPageUnpaidMemberships"
                                class="front-paginate"
                                :total-visible="5"
                                prev-icon="mdi-menu-left"
                                next-icon="mdi-menu-right"
                    ></v-pagination>
                    </v-card-text>
                </v-card>
                <v-card elevation="1" class="mt-3" v-if="$page.props.p['members.payments.read']">
                    <v-card-title>{{ $page.props.lang.earningsCurrentMonth || "Earnings - current month" }}</v-card-title>
                    <v-card-text>
                        <vue-frappe v-if="renderChart"
                            id="test"
                            :labels="chartLabels"
                            :height="300"
                            :bar-options="{spaceRatio: 0.2}"
                            :tooltip-options="tooltipOptions"
                            :colors="[$page.props.organization.themeOptions.primary]"
                            :dataSets="this.chartData">
                        </vue-frappe>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <v-card elevation="1" v-if="$page.props.p['reports']">
                    <v-card-title>{{ $page.props.lang.attendance || "Attendance"}}</v-card-title>
                    <v-row>
                        <v-col cols="12" md="4" sm="4" lg="4" :class="$vuetify.breakpoint.smAndUp ? 'text-left' : 'text-center'">
                            <div>
                                <span class="attendance-value">{{ attendace_now }}<br></span>
                                <span class="attendance-title">{{ $page.props.lang.currently_in_session || "Right now"}}<br></span>
                                <span class="attendance-subtitle">({{ $page.props.lang.in_session || "in session"}})</span>
                                <v-divider v-if="$vuetify.breakpoint.xs" class="mt-3"></v-divider>
                            </div>
                        </v-col>
                        <v-divider v-if="$vuetify.breakpoint.smAndUp" vertical class="mb-3"></v-divider>
                        <v-col cols="12" md="4" sm="4" lg="4" :class="$vuetify.breakpoint.smAndUp ? 'text-left' : 'text-center'">
                            <div>
                                <span class="attendance-value">{{ attendance_today }}<br></span>
                                <span class="attendance-title">{{ $page.props.lang.today || "Today"}}<br></span>
                                <span class="attendance-subtitle">({{ $page.props.lang.so_far || "so far"}})<br></span>
                                <v-divider v-if="$vuetify.breakpoint.xs" class="mt-3"></v-divider>
                            </div>
                        </v-col>
                        <v-divider v-if="$vuetify.breakpoint.smAndUp" vertical class="mb-3"></v-divider>
                        <v-col cols="12" md="4" sm="4" lg="4" :class="$vuetify.breakpoint.smAndUp ? 'text-left' : 'text-center'">
                            <inertia-link :href="'/backoffice/members?absence=3'"><span class="attendance-value">{{absent_month}}<br></span></inertia-link>
                            <span class="attendance-title">{{ $page.props.lang.absent || "Absent"}}<br></span>
                            <span class="attendance-subtitle">({{ $page.props.lang.last_30_days || "last 30 days"}})</span>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card elevation="1" class="today-events" style="margin-top:25px">
                    <v-card-title>{{ $page.props.lang.today_events || "Today events"}}</v-card-title>
                    <v-card-text v-if="appointments != 0">
                        <ul class="list">
                            <li v-for="event in todayEvents" class="event" :key="event.id">
                                <div class="wrap" :style="{ borderLeft: '12px solid' + event.color }">
                                    <p class="event-title">{{ event.name }} {{ event.start | formatDate }}</p>
                                    <p class="time">
                                        {{ event.start | formatTime }}h - {{ event.end | formatTime }}h
                                        ({{ event.duration }} {{ $page.props.lang.minutes || 'minutes' }})
                                    </p>
                                    <div class="members">
                                        <div v-for="trainer in event.trainers" :key="trainer.id" class="trainer">
                                        <v-avatar size="22"><img :src="trainer.profile_photo_url + '?w=44'" alt=""></v-avatar>
                                        <p> {{ trainer.first_name }} {{ trainer.last_name }} </p>
                                        </div>
                                    </div>
                                    <div class="members">
                                        <div v-for="member in event.members" :key="member.id" class="member">
                                            <v-avatar size="22"><img :src="member.profile_photo_url + '?w=44'" alt=""></v-avatar>
                                            <p>{{ member.first_name }} {{ member.last_name }}</p>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </v-card-text>
                    <v-card-text v-else class="text-center font-weight-light text--disabled">{{ $page.props.lang.no_today_events || "No scheduled events..."}}</v-card-text>
                </v-card>
                <v-card elevation="1" class="mt-3" v-if="$page.props.p['calendar.own.complete'] || $page.props.p['calendar.all.complete']">
                    <v-overlay :value="loadingPastAppointments" :absolute="true" :light="true">
                            <v-progress-circular
                                color="#8b1f62"
                                indeterminate
                                size="64"
                            ></v-progress-circular>
                        </v-overlay>
                    <v-card-title>{{ $page.props.lang.past_events || "Past uncompleted appointments"}}</v-card-title>
                    <v-card-text>
                        <v-data-table
                        v-if="pastAppointments.total != 0"
                        :headers="expAppointmentsHeaders"
                        :items="pastAppointments.data"
                        :server-items-length="pastAppointments.total"
                        item-key="item.id"
                        :items-per-page="pastAppointments.per_page"
                        mobile-breakpoint="0"
                        hide-default-footer>
                            <template v-slot:item.title="{ item }">
                                    {{ item.appointment.course.title }}
                            </template>
                             <template v-slot:item.start_date="{ item }">
                               {{ item.appointment.start_date | fullDate }}
                            </template>
                            <template v-slot:item.full_name="{ item }">
                                 {{ item.member.full_name }}
                            </template>

                            <template v-slot:item.action="{ item }">
                                <v-btn @click="showModal(item.appointment_id, item.member_id)" icon style="background:#eeeeee" :id="'complete-'+item.appointment_id+'-'+item.member_id">
                                    <v-icon>mdi-checkbox-marked-outline</v-icon>
                                    <v-tooltip :activator="'#complete-'+item.appointment_id+'-'+item.member_id" bottom open-delay="500">
                                        <span>{{$page.props.lang.complete_appointment || "Complete appointment"}}</span>
                                    </v-tooltip>
                                </v-btn>
                            </template>
                        </v-data-table>

                    <v-card-text v-else class="text-center font-weight-light text--disabled">{{ $page.props.lang.no_past_events || "All previous appointments are completed..."}}</v-card-text>
                    <v-pagination v-model="pastAppointments.current_page"
                                 :length="pastAppointments.last_page"
                                 :total-visible="7"
                                 @input="currentPagePastAppointments()"
                                 prev-icon="mdi-menu-left"
                                 next-icon="mdi-menu-right"
                                 class="front-paginate"
                    ></v-pagination>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <AttendModal v-if="attendAppointmentModal"
        :open="attendAppointmentModal"
        :appointment="currentAppointment"
        @close="attendAppointmentModal = false">
        </AttendModal>


        <PaymentModal v-if="PaymentModal"
        :modal="PaymentModal"
        :member_id="this.member_id"
        :period_id="this.current_period_id"
        :payment_types="this.payment_types"
        @close="PaymentModal = false">
        </PaymentModal>

    </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import Pagination from '@/js/Components/Pagination'
import AttendModal from '@/js/Pages/Backoffice/Home/Components/AttendModal'
import PaymentModal from '@/js/Components/PaymentModal'
import EventBus from '@/js/eventbus'
export default {
    metaInfo() {
        return {
            title: this.$page.props.lang.title || 'Dashboard'
        }
    },
    layout: AppLayout,
    components:{
        Pagination,
        AttendModal,
        PaymentModal
    },
    props: {
        active_members: Number,
        latest_members: Number,
        attendace_now:Number,
        attendance_today: Number,
        absent_month: Number,
        earnings: String,
        debts: String,
        appointments: Array,
        payment_types: Array,
        transactions: Array,
        organization: Object,
        lang: Object
    },
    data(){
        return {
            page:1,
            transactionsData: this.transactions,
            attendAppointmentModal: false,
            paymentMembershipModal: false,
            PaymentModal: false,
            current_period_id:null,
            periods:[],
            member_id: null,
            selectedMember: {
                appointment_id: null,
                id: null,
            },
            pastAppointments: {
                total:0,
                data:[]
            },
            unpaidMemberships: {
                total:0,
                data:[]
            },
            unpaidPeriod: null,
            loadingPastAppointments: false,
            loadingUnpaidMemberships: false,
            selectedMemberData: {
                member_id: null,
                appointment_id: null,
                title: '',
                start_date: '',
                trainer_full_name: '',
                trainer_last_name: '',
                trainer_profile_photo: '',
                member_name: '',
                member_profile_photo: '',
                subscriptions: [],
                status: null
            },
            unpaidMembershipsHeaders: [
                { text: this.lang.member || "Member", value: 'full_name', align:'start', sortable: false },
                { text: this.lang.membership_name || "Membership", value: 'name', align:'start', sortable: false },
                { text: this.lang.period || "Period", value: 'current_period', align:'start', sortable: true },
                { text: this.lang.amount || "Amount", value: 'price', align:'right', sortable: true },
                { text: "", value: 'action', align:'right', sortable: false }
            ],
             expAppointmentsHeaders: [
                { text: this.lang.appointment || "Appointment", value: 'title', align:'start', sortable: false },
                { text: this.lang.date || "Date", value: 'start_date', align:'start', sortable: false },
                { text: this.lang.member || "Member", value: 'full_name', align:'start', sortable: false },
                { text: "", value: 'action', align:'right', sortable: false }
            ],
            renderChart: false,
            tooltipOptions: {
                label: '',
                formatTooltipX: () => '',
                formatTooltipY: (d) => d + ' ' + this.organization.settings.currency
            },
            chartMonth: '',
            selectedEvent: {

            }
        }
    },
    computed: {
        todayEvents() {
            return this.appointments.map(item => {
                let duration = null
                let start = moment(item.start)
                let end = moment(item.end)
                duration = end.diff(start, 'minutes')
                item.duration = duration
                return item
            })
        },
        chartLabels() {
            return this.transactionsData.map(item => {
                return moment(item.day).format('DD')
            })
        },
        chartData() {
            let values = this.transactionsData.map(item => {
                return item.amount
            })
            return [{
                name: "", chartType: 'bar',
                values: values
            }]
        }
    },
    mounted() {
        this.renderChart = true
    },
    created(){


        this.getPastAppointments();
        this.getUnpaidMemberships();

        EventBus.$on('CLOSE_ATTENDENSE_MODAL', (p) => {

            this.getPastAppointments(this.pastAppointments.current_page)

            this.attendAppointmentModal = false;
        })

        EventBus.$on('CLOSE_PAYMENT_MODAL', (p) => {

            this.getUnpaidMemberships(this.unpaidMemberships.current_page)

            this.PaymentModal = false;
        })

    },
    methods: {
        openKioskMode(){
            window.location.href = "/backoffice/kiosk/classes";
        },
        currentPagePastAppointments(){

            this.getPastAppointments(this.pastAppointments.current_page)

        },
        currentPageUnpaidMemberships(){

            this.getUnpaidMemberships(this.unpaidMemberships.current_page)
        },
        showModal(appointment_id, member_id){

             axios.get('/backoffice/home/appointment/'+ appointment_id +'/member/'+ member_id)
                    .then(response => {
                        if(response.data.status == "OK"){
                            this.currentAppointment =  response.data.appointment;
                            this.attendAppointmentModal = true
                    }
                }).catch(error => {
                    console.log("Server Error!")
                })
        },

        showPaymentModal(period_id, member_id){
            this.member_id = member_id;
            this.current_period_id = period_id;
            this.PaymentModal = true;

        },

        getPastAppointments(page = 1){
            this.loadingPastAppointments = true;
            axios.get('/backoffice/home/past_appointments', {params: {page:page}})
                .then((r) => {
                    this.loadingPastAppointments = false;
                    this.pastAppointments = r.data;
                });
        },

        getUnpaidMemberships(page = 1){
            this.loadingUnpaidMemberships = true;
            axios.get('/backoffice/home/unpaid_memberships', {params: {page:page}})
              .then((r) => {
                  this.loadingUnpaidMemberships = false;
                  this.unpaidMemberships = r.data;
              });
    }
}
}
</script>
